import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'colli/type',
    pluginName: 'LOGISTIC',
    entityName: 'COLLI_TYPE',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
    fetchSuccessUseBackendMessage: false,
    fetchFailedUseBackendMessage: false,
    createSuccessUseBackendMessage: true,
    createFailedUseBackendMessage: true,
    deleteSuccessUseBackendMessage: false,
    deleteFailedUseBackendMessage: false,
    loadSuccessUseBackendMessage: false,
    loadFailedUseBackendMessage: false,
    editSuccessUseBackendMessage: false,
    editFailedUseBackendMessage: false,
    bulkDeleteSuccessUseBackendMessage: false,
    bulkDeleteFailedUseBackendMessage: false
});

// Fetch ColliType action creators
export const fetchColliTypeInit = () => {
    return crudActions.fetchInit();
};
export const fetchColliTypeStart = () => {
    return crudActions.fetchStart();
};
export const fetchColliTypeSuccess = (fetchColliTypeCount, listColliTypeCount) => {
    return crudActions.fetchSuccess(fetchColliTypeCount, listColliTypeCount);
};
export const fetchColliTypeFail = () => {
    return crudActions.fetchFail();
};


export const fetchColliTypeCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchColliTypeStart());
        try {
            let countRes = await rest.post("colli/type/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchColliTypeSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchColliTypeFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch colli types."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchColliTypeFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch colli types."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}


export const fetchColliType = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchColliTypeStart());
        try {
            let listRes = await rest.post("colli/type/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchColliTypeSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchColliTypeFail());
            return []

        } catch (error) {
            dispatch(fetchColliTypeFail());
            return []

        }
    }
}

// Create colliType  action creators
export const createColliTypeInit = () => {
    return crudActions.createInit();
};
export const createColliTypeStart = () => {
    return crudActions.createStart();
};
export const createColliTypeSuccess = colliType => {
    return crudActions.createSuccess(colliType);
};
export const createColliTypeFail = error => {
    return crudActions.createFail(error);
};

export const createColliType = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createColliTypeStart());
        try {
            let res = await rest.post('/colli/type/create', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully created colli type.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(createColliTypeFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create colli type."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create colli type."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createColliTypeFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}



// load colli type
export const loadColliTypeInit = () => { return crudActions.loadInit(); };
export const loadColliType = id => {
    return async dispatch => {
        await crudActions.load(dispatch, id);
    };
};


// Edit colli type action creators
export const editColliTypeInit = () => {
    return crudActions.editInit();
};
export const editColliTypeStart = () => {
    return crudActions.editStart();
};
export const editColliTypeSuccess = colli => {
    return crudActions.editSuccess(colli);
};
export const editColliTypeFail = error => {
    return crudActions.editFail(error);
};


export const editColliType = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editColliTypeStart());
        try {
            let res = await rest.post('/colli/type/save', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully updated colli type.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editColliTypeFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit colli type."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit colli type."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editColliTypeFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Bulk delete colli types 
export const bulkDeleteColliTypesInit = () => {
    return crudActions.bulkDeleteInit()
};
export const bulkDeleteColliTypesStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteColliTypesSuccess = result => {
    return crudActions.bulkDeleteSuccess(result);
};
export const bulkDeleteColliTypesFail = error => {
    return crudActions.bulkDeleteFail(error);
};

export const bulkDeleteColliTypes = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteColliTypesStart());
        try {
            let res = await rest.post('/colli/type/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteColliTypesSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted colli types.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteColliTypesFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete colli types."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete colli types."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteColliTypesFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// list colli types
export const listColliTypes = (params, options) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/colli/type/list', { listAll: true, ...params }, options);
            if (res.data && res.data.succeeded) {
                const colliTypes = [];
                for (var colliType of res.data.result.data) {
                    colliTypes.push({
                        value: colliType.ColliTypeID,
                        displayValue: colliType.Name ? colliType.Name : "-",
                        holderColliTypes: colliType.ColliHolderTypes.map(type => type.ColliTypeID),
                        allowHolderColliIDNull: colliType.AllowHolderColliIDNull
                    });
                }
                return colliTypes.sort((a, b) => a.displayValue.localeCompare(b.displayValue));
            }
            else {
                if (res && res.canceled) {
                    return [];
                }
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];

        }
    };
};

export const listProductTypes = (params, options) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/product-type/list', params, options);
            if (res.data && res.data.succeeded) {
                const productTypes = [];
                for (var productType of res.data.result.data) {
                    productTypes.push({
                        value: `${productType.ProductTypeID}`,
                        label: `${productType.Name}`,
                        key: `${productType.Key}`
                    });
                }
                return productTypes.sort((a, b) => a.label.localeCompare(b.label));
            }
            else {
                if (res && res.canceled) {
                    return [''];
                }
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
};

export const generatePreset = (params) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('colli/type/generate-preset', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully generate preset.`,
                    options: {
                        variant: 'success'
                    }
                });
                return true;
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return false;
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return false;

        }
    };
};